import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function dm_nav() {

    // gsap.registerPlugin(ScrollTrigger);
    // reset_scroll_triggers();
    // function reset_scroll_triggers(){
    //     console.log(">> reset_scroll_triggers ")
    //     $(window).trigger('resize');
    //     ScrollTrigger.killAll();
    //     ScrollTrigger.refresh();
    // }

    let $ww = $(window).width(),
        $body = $('body'),
        $navbarToggler = $('.nav-toggler'),
        $submenu = $('header .sub-menu'),
        $svgPaths = $('header .nav-bg svg path'),
        $header = $('header');

    $svgPaths.each(function () {
        const length = this.getTotalLength();
        $(this).css({
            strokeDasharray: length,
            strokeDashoffset: length
        });
    });

    if ($(window).scrollTop() === 0) {
        $body.addClass('scrolled-top');
    }

    $navbarToggler.on('click', function () {
        $(this).toggleClass('is-active');

        if ($body.hasClass('menu-open')) {
            $body.removeClass('menu-open');
            $header.css('right', '0');
            setTimeout(() => {
                $header.css('right', 'auto');
            }, 501);

            $svgPaths.each(function () {
                const length = this.getTotalLength();
                gsap.to(this, {
                    strokeDashoffset: length,
                    duration: 0.8,
                    ease: "power2.in",
                    delay: 2
                });
            });

        } else {
            $body.addClass('menu-open');
            $header.css('right', '0');

            gsap.to($svgPaths, {
                strokeDashoffset: 0,
                duration: 4,
                ease: "power2.out",
                stagger: 0.5
            });
        }

        // setTimeout(function () {
        //     $submenu.removeClass('is-active');
        //     $('.menu-item-has-children > a, .menu-item-has-children + li > a, .menu-item-has-children + li + li:last-child > a').removeClass('move-left is-active');
        // }, 500);
    });

    if ($ww < 768) {
        $submenu.prepend('<li class="menu-item mt-0"><a href="#" class="nav-back mt-0" title="Back">Back</a></li>');

        $('.has-submenu > a').on('click', function (e) {
            e.preventDefault();
            $('.menu-item-has-children').addClass('no-events');
            $('.menu > .menu-item > a').addClass('move-left');
            $(this).siblings().find('.sub-menu').removeClass('is-active');
            $(this).siblings().find('a').removeClass('is-active');
            $(this).siblings('.sub-menu').addClass('is-active');
            $(this).addClass('is-active');
        });

        $('.nav-back').on('click', function (e) {
            e.preventDefault();
            $submenu.removeClass('is-active');
            $('.menu-item-has-children').removeClass('no-events');
            $('.menu-item > a').removeClass('move-left is-active');
        });
    }
}

export { dm_nav };
